import React, { Component } from "react";
import { Button } from "antd";
import IntlTelInput from "react-intl-tel-input";
import PhoneVerificationIcon from "icons/PhoneVerificationIcon";

import "react-intl-tel-input/dist/main.css";
import "./EnterPhoneNumberLayout.scss";
import withUseIntl from "./withUseIntl";

class EnterPhoneNumberLayout extends Component {
  state = {
    phoneNumber: "",
    countryCode: ""
  };

  handleProceed = () => {
    const { phoneNumber, countryCode } = this.state;
    this.props.proceedHandler({ phoneNumber, countryCode })
  };

  onPhoneNumberChangeHandler = (_, phoneNumber, country) => {
    if (/^\+?\d*$/.test(phoneNumber) && phoneNumber.length > 0) {
      this.setState({ phoneNumber, countryCode: country.dialCode })
    }
  }

  render() {
    const intl = this.props.useIntl;
    return(
      <div className="enter-phone-number-wrapper verify-page-modal">
        <div className="inner-content">
          <div className="svg-icon">
            <PhoneVerificationIcon />
          </div>
          <h2 className="fw-700">{intl.formatMessage({id:"app.common.phone.number"})}</h2>
          <p className="describe">
            {intl.formatMessage({id:"app.page.enterphonenumberlayout.please.enter.phone"})}
          </p>
          <div className="phone-input">
            <IntlTelInput
              preferredCountries={["sg"]}
              separateDialCode={true}
              autoPlaceholder={false}
              onPhoneNumberChange={this.onPhoneNumberChangeHandler}
              value={this.state.phoneNumber}
            />
          </div>
          <div className="buttons-section">
            <Button
              type="primary"
              className="btn-wide-md"
              onClick={this.handleProceed}
            >
              {intl.formatMessage({id: "app.page.enterphonenumberlayout.proceed.to.signin"})}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default withUseIntl(EnterPhoneNumberLayout);
